export default "__VITE_ASSET__Bcw4mB1i__"